import { render } from "./CatalogView.vue?vue&type=template&id=6fcb26e8&scoped=true"
import script from "./CatalogView.vue?vue&type=script&lang=js"
export * from "./CatalogView.vue?vue&type=script&lang=js"

import "./CatalogView.vue?vue&type=style&index=0&id=6fcb26e8&scoped=true&lang=css"
import "./CatalogView.vue?vue&type=style&index=1&id=6fcb26e8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fcb26e8"]])

export default __exports__